import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../Hooks/useAuth';
import useLogout from '../../Hooks/useLogout';
import { CarbonButton } from '../../Utils/generalStyles';
import useAxiosPrivate from '../../Hooks/useAxiosPrivate';
import {
  AccountContainer,
  AccountHeader,
  AccountLabel,
  AccountWrapper,
  ProfileWrapper,
  AccountTop,
  AccountTextWrapper,
  AccountDivider,
  SmallHeader,
  InfoWrapper,
  AccountInfoText,
  SmallHeaderWrapper,
  EditText,
  EditIcon,
  AddIcon,
  RemoveIcon,
  WalletWrapper,
  WalletText,
} from './accountInfoElements';

// Popups
import Popup from '../../Utils/popup/popup';
import ChangePasswordPopup from '../../Utils/popup/chnagePassword/changePasswordPopup';
import UpdateAccountPopup from '../../Utils/popup/updateAccount/updateAccountPopup';
import AddWalletPopup from '../../Utils/popup/addWallet';

const AccountInfoSection = () => {
  const [passwordOpen, setPasswordOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);
  const [addWalletOpen, setAddWalletOpen] = useState(false);

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const logout = useLogout();

  const { auth, setAuth } = useAuth();

  const signOut = async () => {
    const confirmed = window.confirm('Are you sure you want to logout?');
    if (!confirmed) return;

    await logout();
    navigate('/login');
  };

  const removeWallet = () => {
    const confirmed = window.confirm('Are you sure you want to remove your wallet?');
    if (!confirmed) return;

    axiosPrivate.post(
      '/addWallet',
      JSON.stringify({
        memberWallet: '',
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.status === 'error') {
        console.log('error when removing');
      } else {
        setAuth((prev) => ({
          ...prev,
          wallet: '',
        }));
      }
    }).catch((error) => {
      console.log(error);
    });
  };

  return (
    <AccountContainer>
      <Popup header="Change your password" trigger={passwordOpen} setOpen={setPasswordOpen}>
        <ChangePasswordPopup />
      </Popup>
      <Popup header="Edit account info" trigger={accountOpen} setOpen={setAccountOpen}>
        <UpdateAccountPopup setOpen={setAccountOpen} />
      </Popup>
      <Popup header={auth.wallet ? 'Change your wallet' : 'Connect your wallet'} trigger={addWalletOpen} setOpen={setAddWalletOpen}>
        <AddWalletPopup setOpen={setAddWalletOpen} />
      </Popup>
      <AccountWrapper>
        <ProfileWrapper>
          <AccountTop>
            <AccountHeader>Your Profile</AccountHeader>
          </AccountTop>
          <AccountTextWrapper>
            <SmallHeader>Profile info</SmallHeader>
            <AccountDivider />
            <InfoWrapper>
              <AccountLabel>Full name:</AccountLabel>
              <AccountInfoText>{`${auth.name} ${auth.surname}`}</AccountInfoText>
            </InfoWrapper>
            <AccountDivider />
            <InfoWrapper>
              <AccountLabel>Email address:</AccountLabel>
              <AccountInfoText>{auth.email}</AccountInfoText>
            </InfoWrapper>
            <AccountDivider />
            <SmallHeaderWrapper>
              <InfoWrapper>
                <AccountLabel>Password:</AccountLabel>
                <AccountInfoText>**************</AccountInfoText>
              </InfoWrapper>
              <EditText onClick={() => setPasswordOpen(true)}>
                Change password
                <EditIcon />
              </EditText>
            </SmallHeaderWrapper>
          </AccountTextWrapper>
        </ProfileWrapper>
        <ProfileWrapper>
          <AccountTextWrapper>
            <SmallHeaderWrapper>
              <SmallHeader>Account info</SmallHeader>
              <EditText onClick={() => setAccountOpen(true)}>
                Edit account info
                <EditIcon />
              </EditText>
            </SmallHeaderWrapper>
            <AccountDivider />
            <InfoWrapper>
              <AccountLabel>Phone:</AccountLabel>
              <AccountInfoText>{auth.phone}</AccountInfoText>
            </InfoWrapper>
            <AccountDivider />
            <InfoWrapper>
              <AccountLabel>Company:</AccountLabel>
              <AccountInfoText>{auth.company}</AccountInfoText>
            </InfoWrapper>
            <AccountDivider />
            <InfoWrapper>
              <AccountLabel>Social media:</AccountLabel>
              <AccountInfoText>{auth.social}</AccountInfoText>
            </InfoWrapper>
            <AccountDivider />
            <InfoWrapper>
              <AccountLabel>Handle:</AccountLabel>
              <AccountInfoText>{auth.handle}</AccountInfoText>
            </InfoWrapper>
          </AccountTextWrapper>
        </ProfileWrapper>
        <ProfileWrapper>
          <AccountTextWrapper>
            <SmallHeaderWrapper>
              <SmallHeader>Wallet info</SmallHeader>
              <EditText onClick={() => setAddWalletOpen(true)}>
                {auth.wallet ? 'Change your wallet' : 'Connect your wallet'}
                <AddIcon />
              </EditText>
            </SmallHeaderWrapper>
            <AccountDivider />
            <WalletWrapper>
              <InfoWrapper>
                <AccountLabel>Wallet:</AccountLabel>
                {auth.wallet
                  ? (<AccountInfoText>{auth.wallet}</AccountInfoText>)
                  : (<AccountInfoText>Not connected</AccountInfoText>)}
              </InfoWrapper>
              {auth.wallet && (
              <WalletText onClick={removeWallet}>
                Remove wallet
                <RemoveIcon />
              </WalletText>
              )}
            </WalletWrapper>
          </AccountTextWrapper>
        </ProfileWrapper>
        <CarbonButton colored onClick={signOut}>Log out</CarbonButton>
      </AccountWrapper>
    </AccountContainer>
  );
};

export default AccountInfoSection;
